import { PlusOutlined } from '@ant-design/icons';
import { useFormItemEnabled } from '@framework/form/item/useFormItemEnabled.ts';
import { t } from '@framework/i18n/intl/i18next.ts';
import { Button, Tooltip } from 'antd';
import { useCallback, useMemo } from 'react';
import { type IRepeatableWidget } from '../IRepeatableWidget.ts';

export interface IAddRowButtonProps {
  widget: IRepeatableWidget;
  itemCount: number;
  onAdd: () => void;
}

/**
 * Pulsante per l'aggiunta di una nuova riga in un repeatable widget.
 */
export function AddRowButton(props: IAddRowButtonProps) {
  const { widget, itemCount, onAdd } = props;

  const repeatRule = widget.rules?.repeatableRange;

  const { visuallyDisabled } = useFormItemEnabled();

  const isMax = useMemo(
    () => repeatRule?.max && repeatRule.max <= itemCount,
    [itemCount, repeatRule],
  );

  const onClickHandler = useCallback(() => {
    if (isMax) return;
    if (visuallyDisabled) return;

    onAdd();
  }, [isMax, visuallyDisabled, onAdd]);

  if (widget.layout?.hideAddButton) {
    return null;
  }

  return (
    <Tooltip
      title={
        //  Se è disabilitato non mostro il tooltip
        !visuallyDisabled && isMax
          ? t(
              'widgets.add-row-buttton.max-options-reached',
              'Numero massimo di opzioni raggiunte',
            )
          : undefined
      }
    >
      <Button
        size="large"
        icon={<PlusOutlined aria-hidden="true" />}
        onClick={onClickHandler}
        disabled={isMax || visuallyDisabled}
      >
        {widget.layout?.buttonText ??
          t('widgets.add-row-buttton.add', 'Aggiungi')}
      </Button>
    </Tooltip>
  );
}
